import { useEffect, useState } from "react";
export function usePromise(fn, deps = []) {
    const [isLoading, setLoading] = useState(true);
    const [isError, setError] = useState(false);
    const [errData, setErrData] = useState(null);
    const [data, setData] = useState(undefined);
    function run() {
        setLoading(true);
        setError(false);
        fn().then(res => {
            setData(res);
        }).catch(err => {
            setError(true);
            setErrData(err);
        }).finally(() => setLoading(false));
    }
    useEffect(() => {
        run();
    }, deps);
    return { isLoading, isError, errData, data, run, setData };
}
